export default [
    {
      path: '/components',
      name: 'components',
      component: () => import('@/views/components/Components.vue'),
    },
  ]
  